import { render, staticRenderFns } from "./seatsioChartDesigner.vue?vue&type=template&id=183bbf3c&scoped=true&"
import script from "./seatsioChartDesigner.vue?vue&type=script&lang=js&"
export * from "./seatsioChartDesigner.vue?vue&type=script&lang=js&"
import style0 from "./seatsioChartDesigner.vue?vue&type=style&index=0&id=183bbf3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183bbf3c",
  null
  
)

export default component.exports